import { loadTypeSchema, type TypeSchema } from './type-schema'
import schemaSource from './schema.jsonc' with { type: 'text' }

export const CASE_SCHEMA_SOURCE: string = schemaSource

export const CASE_TYPE_SCHEMA: TypeSchema = loadTypeSchema(schemaSource)
